import { Layout, Space, Typography, Button, Avatar, Dropdown } from 'antd';
import { UserOutlined, LogoutOutlined, DatabaseOutlined } from '@ant-design/icons';
import { ThemeToggle } from '../common/ThemeToggle';
import { useAuth } from '../../context/AuthContext';

const { Header } = Layout;
const { Title } = Typography;

export function AppHeader() {
  const { logout } = useAuth();

  const userMenuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: logout,
    },
  ];

  return (
    <Header
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
      }}
    >
      <Space>
        <DatabaseOutlined style={{ fontSize: 24, color: '#1677ff' }} />
        <Title level={4} style={{ margin: 0 }}>
          PIM
        </Title>
      </Space>

      <Space size="middle">
        <ThemeToggle />
        <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
          <Button type="text" icon={<Avatar size="small" icon={<UserOutlined />} />} />
        </Dropdown>
      </Space>
    </Header>
  );
}
